// Centralised test IDs for testability
export const AUTH = {
  emailInput: "login-email-input",
  continueBtn: "login-continue-btn",
  otpInput: "login-otp-input",
  otpSubmitBtn: "login-otp-submit-btn",
  otpResendBtn: "login-otp-resend-btn",
  authError: "login-error-message",
  devHint: "login-dev-hint",
};

export const ONBOARDING = {
  legalName: "onb-legal-name",
  ownerName: "onb-owner-name",
  phone: "onb-phone",
  email: "onb-email",
  addressLine: "onb-address-line",
  city: "onb-city",
  state: "onb-state",
  postal: "onb-postal",
  primaryProduct: "onb-primary-product",
  volume: "onb-volume",
  businessType: "onb-business-type",
  taxGst: "onb-tax-gst",
  businessId: "onb-business-id",
  taxId: "onb-tax-id",
  website: "onb-website",
  payoutNumber: "onb-payout-number",
  payoutIfsc: "onb-payout-ifsc",
  payoutHolder: "onb-payout-holder",
  payoutSameAddress: "onb-payout-same-address",
  payoutAddressLine: "onb-payout-address-line",
  payoutCity: "onb-payout-city",
  payoutState: "onb-payout-state",
  payoutPostal: "onb-payout-postal",
  submitBtn: "onb-submit-btn",
};

export const DASHBOARD = {
  root: "dashboard-root",
  copyAccountBtn: "copy-account-btn",
  copyRoutingBtn: "copy-routing-btn",
  copySwiftBtn: "copy-swift-btn",
  fxWidget: "fx-widget",
  payoutCard: "payout-card",
  txnRow: "txn-row",
  copyAllBtn: "copy-all-details-btn",
  downloadPdfBtn: "download-account-pdf-btn",
  contactLink: "contact-link",
  logoutBtn: "logout-btn",
};

export const TXN = {
  root: "txn-detail-root",
  efiraBtn: "download-efira-btn",
  withdrawBtn: "withdraw-btn",
  backBtn: "txn-back-btn",
};

export const WITHDRAW = {
  root: "withdraw-root",
  fileInput: "withdraw-file-input",
  dropzone: "withdraw-dropzone",
  uploadBtn: "withdraw-upload-btn",
  invoiceNumber: "withdraw-invoice-number",
  invoiceAmount: "withdraw-invoice-amount",
  invoiceDate: "withdraw-invoice-date",
  buyerName: "withdraw-buyer-name",
  paymentTypeAdvance: "withdraw-paytype-advance",
  paymentTypeBalance: "withdraw-paytype-balance",
  shippingBill: "withdraw-shipping-bill",
  gstInvoiceNumber: "withdraw-gst-invoice-number",
  gstInvoiceDate: "withdraw-gst-invoice-date",
  confirmBtn: "withdraw-confirm-btn",
  successBanner: "withdraw-success",
  actionCard: "withdraw-action-card",
  generateEmailBtn: "withdraw-generate-email-btn",
  emailPreview: "withdraw-email-preview",
  copyEmailBtn: "withdraw-copy-email-btn",
  downloadAdviceBtn: "withdraw-download-advice-btn",
  goBackBtn: "withdraw-goback-btn",
};

export const EBRC = {
  tracker: "ebrc-tracker",
  selfCertifyBtn: "ebrc-self-certify-btn",
  guide: "ebrc-guide",
  dgftLink: "ebrc-dgft-link",
};

export const CONTACT = {
  waLink: "whatsapp-support-link",
};
